import { useReducer } from "react"

const AuthDataState = {
  auth: {},
  userData: {},
}

export default AuthDataState
